import {ESTIMATION_UPDATE_STEP, 
				ESTIMATION_COMPUTE_SUCCESS, ESTIMATION_COMPUTE_ERROR, ESTIMATION_COMPUTE_RESET,
				ESTIMATION_MAIL_SUCCESS,
			} from '../actions/types';

const defaultState = {
    activeStep:0,
    enterpriseValue: null,
    mailText: null
     // don't forget to change the $nbrButton in _estimation.scss
  };

export default function(state=defaultState, action) {
	switch(action.type) {
    case ESTIMATION_UPDATE_STEP:
			return {...state, 
				activeStep: action.payload,
      };
      
    case ESTIMATION_COMPUTE_SUCCESS:
      return {...state, 
        enterpriseValue: action.payload,
      };
      
    case ESTIMATION_COMPUTE_ERROR:
      return {...state, 
      	enterpriseValue: action.payload,
      };
      
    case ESTIMATION_COMPUTE_RESET:
      return {...state, 
      	enterpriseValue: action.payload,
      };
            
    case ESTIMATION_MAIL_SUCCESS:
      return {...state, 
        mailText: action.payload
       };
       
	}
	return state;
}